import { PaginatedRequestParams } from "api";
import { Dayjs } from "dayjs";
import { MaterialDetailFilterFormValues } from "features/material-details/compoents/Top-bar/type";

export enum LoadingFilterFormField {
  MaterialName = 'MaterialName',
  DriverName = 'DriverName',
  VehicleNumber = "VehicleNumber",
  Date = 'date',
  WeightType = 'WeightType'
}

export type LoadingFilterFormValues = {
  [LoadingFilterFormField.MaterialName]: string | undefined;
  [LoadingFilterFormField.DriverName]: string | undefined;
  [LoadingFilterFormField.VehicleNumber]: string | undefined;
  [LoadingFilterFormField.Date]: [Dayjs | undefined, Dayjs | undefined] | null;
  [LoadingFilterFormField.WeightType]: string | undefined;

};

export type LoadingFilterFormValuesPaginated = LoadingFilterFormValues &
  PaginatedRequestParams;

export type MaterialDetailFormValuesPaginated = MaterialDetailFilterFormValues &
  PaginatedRequestParams;
  